import { Button } from "@mui/material";
import * as yup from "yup";
import { useFormik } from "formik";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useResetPasswordMutation } from "../../redux-toolkit/features/auth/authApiSlice";
import { Link, useParams } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import React from "react";
import { useAlert } from "../../hooks/useAlert";
import bg from "../../assets/Login Page/Desktop/Login Page _ Desktop Background.svg";
import bgmb from "../../assets/Login Page/Mobile/Login Page _ Mobile Background.svg";
import logo from "../../assets/Login Page/Desktop/Logo.png";
import artwork1 from "../../assets/Login Page/Desktop/Artwork 1.png";
import artwork2 from "../../assets/Login Page/Desktop/Artwork 2.png";
import "./Login.css";
import Grid from "@mui/material/Grid";

const validationSchema = yup.object({
  password: yup
    .string("Enter your password")
    .required("Password is required")
    .min(8, "Password must be at least 8 characters")
    .matches(/[0-9]/, "Password must contain at least one number")
    .matches(
      /[^A-Za-z0-9]/,
      "Password must contain at least one special character",
    ),
  confirmPassword: yup
    .string("Confirm your password")
    .oneOf([yup.ref("password"), null], "Passwords must match")
    .required("Confirm password is required"),
});

export const Respassword = () => {
  const [resetPassword] = useResetPasswordMutation();
  const { id, token } = useParams();
  const [passwordType, setPasswordType] = React.useState("password");
  const [cPasswordType, setCPasswordType] = React.useState("password");

  const { displayAlert } = useAlert();

  const getResetPasswordErrorMessage = (error) => {
    if (typeof error?.data === "string") return error.data;
    if (error?.data?.message) return error.data.message;
    if (error?.error?.data?.message) return error.error.data.message;
    if (error?.message) return error.message;
    if (typeof error?.error === "string") return error.error;

    return "Server error.";
  };

  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };
  const toggleConfirmPassword = () => {
    if (cPasswordType === "password") {
      setCPasswordType("text");
      return;
    }
    setCPasswordType("password");
  };

  const formik = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validationSchema: validationSchema,
    onSubmit: () => {},
  });

  const { password, confirmPassword } = formik.values;
  const passwordsMatch =
    Boolean(password) &&
    Boolean(confirmPassword) &&
    password === confirmPassword;
  const showPasswordError = Boolean(password) && Boolean(formik.errors.password);
  const showPasswordMismatch =
    Boolean(confirmPassword) && password !== confirmPassword;
  const isSubmitDisabled =
    !password ||
    !confirmPassword ||
    !passwordsMatch ||
    Boolean(formik.errors.password);

  const resetHandler = async (e) => {
    e?.preventDefault?.();

    if (isSubmitDisabled) return;

    let passwordPayload = { password: formik.values.password };

    try {
      await resetPassword({ password: passwordPayload, id, token }).unwrap();
      displayAlert({
        open: true,
        message: "Password successfully reset.",
        type: "success",
      });
    } catch (err) {
      displayAlert({
        open: true,
        message: getResetPasswordErrorMessage(err),
        type: "error",
      });
    }
  };

  return (
    <>
      <div className="login">
        <img src={bg} className="login__img disableTablet" alt="" />
        <img src={bgmb} className="login__img disableDesktop" alt="" />
        <div className="login__overlay">
          <div className="containerlogin">
            <Grid container alignItems="center" justifyContent="center">
              <Grid className="disableTablet" item lg={6}>
                <div className="login__left">
                  <h1>
                    <i>
                      Welcome to the <br /> Growth Community
                    </i>
                  </h1>
                  <img
                    src={artwork1}
                    className="login__leftimg"
                    width="60%"
                    alt="artwork1"
                  />
                </div>
              </Grid>
              <Grid item xs={12} md={12} lg={6}>
                <div className="login__right">
                  <img
                    src={logo}
                    className="login__rightimg"
                    width="32%"
                    alt="quest logo"
                  />
                  <form className="login__form" onSubmit={resetHandler}>
                    <div className="password__input__wrapper">
                      <input
                        type={passwordType}
                        placeholder="New Password"
                        name="password"
                        className={
                          showPasswordError
                            ? "login__input login__invalid"
                            : "login__input"
                        }
                        value={formik.values.password}
                        onChange={formik.handleChange}
                      />
                      <i
                        className="password__visibility__icon"
                        onClick={togglePassword}
                      >
                        {passwordType === "password" ? (
                          <VisibilityOffIcon />
                        ) : (
                          <VisibilityIcon />
                        )}
                      </i>{" "}
                    </div>
                    {showPasswordError && (
                      <div className="login__error">
                        <ErrorOutlineIcon fontSize="small" color="error" />
                        <span>{formik.errors.password}</span>
                      </div>
                    )}
                    <div className="password__input__wrapper">
                      <input
                        type={cPasswordType}
                        placeholder="Confirm Password"
                        name="confirmPassword"
                        className={
                          showPasswordMismatch
                            ? "login__input login__invalid"
                            : "login__input"
                        }
                        value={formik.values.confirmPassword}
                        onChange={formik.handleChange}
                      />
                      <i
                        className="password__visibility__icon"
                        onClick={toggleConfirmPassword}
                      >
                        {cPasswordType === "password" ? (
                          <VisibilityOffIcon />
                        ) : (
                          <VisibilityIcon />
                        )}
                      </i>
                    </div>
                    {showPasswordMismatch && (
                      <div className="login__error">
                        <ErrorOutlineIcon fontSize="small" color="error" />
                        <span>
                          New password and confirm password do not match
                        </span>
                      </div>
                    )}
                    <Button
                      fullWidth
                      type="submit"
                      disabled={isSubmitDisabled}
                      sx={{
                        marginTop: "40px",
                        backgroundColor: "var(--sblue)",
                        padding: "15x 10px",
                      }}
                      onClick={resetHandler}
                      variant="contained"
                    >
                      Submit
                    </Button>
                    <Link style={{ textDecoration: "none" }} to={"/login"}>
                      <p className="login__forgot">Back To Login</p>
                    </Link>
                  </form>
                </div>
                <img
                  src={artwork2}
                  className="login__leftartwork"
                  width="70px"
                  alt="quest logo"
                />
              </Grid>
              <p className="login__powered">
                Powered by &nbsp;
                <a
                  href="https://www.sliqgroup.com"
                  rel="noreferrer"
                  target="_blank"
                >
                  <b>Sliq Group</b>
                </a>
              </p>
            </Grid>
          </div>
        </div>
      </div>
    </>
  );
};
